import React from "react";
import { Check, CircleDashed, CircleDot, Sparkles } from "lucide-react";

// Distinct hue per lifecycle stage — chosen so the four statuses read
// instantly at a glance on the admin dashboard/rows/sheet:
//   Not Started  → cool stone (inertia, waiting)
//   In Progress  → amber      (warm, active, animated pulse)
//   Completed    → oxblood    (brand-primary "done work" state)
//   Approved     → forest     (final green blessing)
// Each also carries a unique ICON so admins with color-vision differences
// can still tell them apart at a glance.
const STATUS_MAP = {
  not_started: {
    label: "Not Started",
    color: "#5F6B7A",
    bg: "rgba(95, 107, 122, 0.12)",
    ring: "rgba(95, 107, 122, 0.45)",
    Icon: CircleDashed,
    pulse: false,
  },
  in_progress: {
    label: "In Progress",
    color: "#C2410C",
    bg: "rgba(194, 65, 12, 0.12)",
    ring: "rgba(194, 65, 12, 0.45)",
    Icon: CircleDot,
    pulse: true,
  },
  completed: {
    label: "Completed",
    color: "#6B0F1A",
    bg: "rgba(107, 15, 26, 0.10)",
    ring: "rgba(107, 15, 26, 0.45)",
    Icon: Check,
    pulse: false,
  },
  approved: {
    label: "Approved",
    color: "#3F7A2E",
    bg: "rgba(63, 122, 46, 0.14)",
    ring: "rgba(63, 122, 46, 0.50)",
    Icon: Sparkles,
    pulse: false,
  },
};

export const StatusBadge = ({ status, className = "" }) => {
  const meta = STATUS_MAP[status] || STATUS_MAP.not_started;
  const Icon = meta.Icon;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`font-mono-tag inline-flex items-center gap-1.5 text-[10px] font-bold tracking-wide px-2.5 py-1 rounded-sm ${className}`}
      style={{
        color: meta.color,
        backgroundColor: meta.bg,
        border: `1px solid ${meta.ring}`,
      }}
    >
      <Icon
        className={`w-3 h-3 ${meta.pulse ? "animate-pulse" : ""}`}
        strokeWidth={2.5}
        style={{ color: meta.color }}
        aria-hidden="true"
      />
      {meta.label}
    </span>
  );
};

export const STATUS_LABELS = STATUS_MAP;
